import React from "react";

import { Drawer } from "../../../components/Drawer";
import { Input } from "../../../components/Input";
import { Button } from "../../../components/Button";
import { Hairline } from "../../../components/Hairline";
import { Label } from "../../../components/Label";
import { Icon } from "../../../components/core/Icon";

import styles from "../../../../styles/block-product-sku.module.scss";
import { EnvironmentsAPI } from "../../../../providers/EnvironmentsAPI";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import { Message } from "../../../components/Message";
import { Empty } from "../../../components/Empty";
import { Checkbox } from "../../../components/Checkbox";
import { CatalogAPI } from "../../../../providers/CatalogAPI";
import { Catalog } from "../../../utils/Catalog";
import { Loading } from "../../../components/Loading";
import Toggle2 from "shared/components/Toggle2";
import { If } from "shared/components/control-statements";
import { Radio } from "@components";

export default class BlockProductSKU extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allSku: false,
      active: false,
      catalog: null,
      sku: null,
      quantity: null,
      limits: [],
      pageLoading: true,
      saveLoading: false,
      step: null,
    };
  }

  async componentDidMount() {
    const environmentId = EnvironmentStorage.getSelectedEnvironment();

    const catalogResponse = await CatalogAPI.getCatalogByService(
      null,
      "DELIVERY"
    );
    const catalog = catalogResponse.getData({
      items: [],
      type: "catalog",
      service: "DELIVERY",
    });

    const configurations = await EnvironmentsAPI.getConfigurationsByAlias(
      environmentId,
      "catalog_sku_limits",
      []
    );

    const limits =
      configurations?.limits?.length > 0 ? configurations?.limits : [];

    this.setState({
      pageLoading: false,
      active: !!configurations?.active,
      limits,
      catalog,
    });
  }

  addLimit() {
    const { catalog, limits, sku, quantity, allSku } = this.state;

    if (!quantity) {
      return;
    }

    if (!allSku) {
      const products = {};
      Catalog.executeOnSchema(catalog, (children) => {
        if (["step", "question", "option"].includes(children.type)) {
          const itemSize =
            (children?.sizes || []).find((size) => size.sku) || {};
          const itemSku = itemSize?.sku || children?.sku;

          if (itemSku === sku) {
            products[sku] = {
              ...(products[itemSku] || {}),
              name: children?.name,
              description: children?.description,
              image: children?.image,
            };
          }
        }
      });

      if (Object.keys(products).length === 0) {
        alert({
          text: `Nenhum produto encontrado com o SKU "${sku}" no cardápio do Delivery`,
          buttonText: "Ok",
        });
        return;
      }
    }

    const limit = (limits || []).find((limit) => limit.sku === sku);

    if (!limit) {
      limits.push({
        sku,
        quantity,
      });
    } else {
      limit.quantity = quantity;
    }

    this.setState({
      limits,
      allSku: false,
      sku: "",
      quantity: "",
    });
  }

  checkIfIsValid() {
    const { sku, quantity, allSku } = this.state;

    if (allSku) {
      return quantity;
    }

    return sku && quantity;
  }

  removeLimit(sku) {
    const { limits } = this.state;

    const updatedLimits = limits.filter((limit) => limit.sku !== sku);
    this.setState({ limits: updatedLimits });
  }

  async save() {
    const { active, limits } = this.state;

    this.setState({ saveLoading: true });

    const environmentId = EnvironmentStorage.getSelectedEnvironment();

    const blockResponse = await EnvironmentsAPI.putConfigurationsByAlias(
      environmentId,
      "catalog_sku_limits",
      {
        catalog_sku_limits: {
          active,
          limits,
        },
      }
    );

    if (blockResponse.getErrors([]).length > 0) {
      alert({
        text: blockResponse.getErrors()[0],
        buttonText: "Ok",
      });
      this.setState({ saveLoading: false });
      return false;
    }

    alert({
      text: "Configurações alteradas sucesso",
      buttonText: "Ok",
    });

    this.setState({ saveLoading: false });
    return true;
  }

  render() {
    const { visible, onClose } = this.props;
    const {
      active,
      sku,
      quantity,
      limits,
      allSku,
      pageLoading,
      saveLoading,
      step,
    } = this.state;

    const sortedLimits = limits.sort((prev, next) => {
      const prevSortableValue = prev.sku ? 1 : 0;
      const nextSortableValue = next.sku ? 1 : 0;
      return prevSortableValue - nextSortableValue;
    });

    const limitLength = Object.values(limits).length;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title={step === "configure" ? "Configurar limite" : "Limite de produto"}
        subtitle={step === "configure" && "Limite de produto"}
        showBackButton={step === "configure"}
        backButton={() => this.setState({ step: null })}
      >
        {pageLoading ? (
          <div className="d-flex align-center justify-center h-100 w-100">
            <Loading />
          </div>
        ) : (
          <>
            <If cond={step !== "configure"}>
              <Message type="warning" className="w-100 mb-20">
                <p>
                  Ao ativar essa configuração, pedidos contendo itens em
                  quantidades superiores ao limite estabelecido serão
                  automaticamente recusados.
                </p>
              </Message>

              <div className={styles.box}>
                <Toggle2
                  id="payment-online"
                  title="Ativar limite de produto"
                  checked={active}
                  onChange={() => {
                    this.setState({
                      active: !active,
                    });
                  }}
                />
              </div>
            </If>

            <If cond={step === "configure"}>
              <Radio
                family="variableType"
                value={false}
                checked={allSku}
                className="mb-15"
                onChange={() => {
                  this.setState({
                    sku: sku,
                    allSku: false,
                  });
                }}
              >
                Aplicar limite em produtos específicos
              </Radio>
              <Radio
                family="variableType"
                value={true}
                checked={allSku}
                onChange={() => {
                  this.setState({
                    sku: null,
                    allSku: true,
                  });
                }}
              >
                Aplicar limite para todos os produtos
              </Radio>

              <If cond={allSku}>
                <Hairline className="mt-20 mb-20" />
                <Label>Quantidade máxima</Label>
                <Input
                  id="quantity"
                  name="quantity"
                  type="number"
                  design="mini"
                  placeholder=""
                  className="w-100"
                  maxLength={4}
                  defaultValue={quantity}
                  value={quantity}
                  onChange={(e) => {
                    this.setState({ quantity: e.target.value });
                  }}
                />
              </If>

              <If cond={!allSku}>
                <Hairline className="mt-20 mb-20" />
                <div className="d-flex align-center gap-10 w-100">
                  <div className="d-flex flex-column w-100">
                    <Label>Código PDV</Label>
                    <Input
                      id="sku"
                      name="sku"
                      design="mini"
                      placeholder="----"
                      maxLength={60}
                      className="w-100"
                      defaultValue={sku}
                      value={sku}
                      onChange={(e) => {
                        this.setState({ sku: e.target.value });
                      }}
                    />
                  </div>
                  <div className="d-flex flex-column w-100">
                    <Label>Quantidade máxima</Label>
                    <Input
                      id="quantity"
                      name="quantity"
                      type="number"
                      design="mini"
                      placeholder=""
                      className="w-100"
                      maxLength={4}
                      defaultValue={quantity}
                      value={quantity}
                      onChange={(e) => {
                        this.setState({ quantity: e.target.value });
                      }}
                    />
                  </div>
                </div>
              </If>

              <Button
                className="mt-10"
                onClick={() => this.addLimit()}
                disabled={!this.checkIfIsValid()}
              >
                Adicionar
              </Button>

              <Hairline className="mt-20 mb-20" />

              <Label>Limites ({limitLength})</Label>

              {limitLength === 0 ? (
                <div className={styles.empty}>
                  <div className={styles.icon}>
                    <Icon name="fa-ban" light size="lg" />
                  </div>
                  <p>Nenhum produto possui limite registrado até o momento.</p>
                </div>
              ) : (
                <div className={styles.limits}>
                  {sortedLimits.map((limit) => (
                    <div className={styles.limit} key={limit.sku}>
                      <div className="d-flex align-center w-100 justify-between">
                        <p className={styles.sku}>
                          {limit.sku || "Todos os produtos"}
                        </p>
                        <div className="d-flex align-center">
                          <p className={styles.quantity}>{limit.quantity}x</p>
                          <div className={styles.separator} />
                          <div
                            className={styles.remove}
                            onClick={() => this.removeLimit(limit.sku)}
                          >
                            <Icon name="fa-times" />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </If>

            <div className={styles.footer}>
              <If cond={(!step && !active) || step === "configure"}>
                <Button
                  className="w-100"
                  design="primary"
                  disabled={saveLoading}
                  loading={saveLoading}
                  onClick={() => this.save()}
                >
                  Salvar
                </Button>
              </If>
              <If cond={!step && active}>
                <Button
                  className="w-100"
                  design="primary"
                  onClick={() => this.setState({ step: "configure" })}
                >
                  Configurar produtos
                </Button>
              </If>
            </div>
          </>
        )}
      </Drawer>
    );
  }
}
